module.exports = __webpack_public_path__ + "img/banner.2b695350.png";